import { COOKIES_KEYS } from '@/constants';
import { CookiesStorageService } from '../services/cookiesStorageService';
import { getUrlParams } from './getUrlParams';
import { normalizeSearchParams } from './normalizeSearchParams';
import { windowIsReady } from './windowIsReady';

type TReturn = string | URLSearchParams | Record<string, unknown>;

export const generateUrlParams = <T extends TReturn>(
	paramsFormat?: 'search' | 'string',
	extraParams?: Record<string, unknown>,
) => {
	let generatedFbc = '';

	// get data from url
	const { fbclid, uuid }: Record<string, string> = getUrlParams();

	// get data from cookies
	const uuidFromCookies = CookiesStorageService.get(COOKIES_KEYS.UUID, uuid);

	// generate custom params
	const fbc = getFbc(generatedFbc, fbclid);
	const fbp = getFbp();

	// generate new object with url params
	const queryParams: Record<string, unknown> = {
		...getUrlParams(),
		...extraParams,
		uuid: uuidFromCookies,
		fbc,
		fbp,
	};

	return normalizeSearchParams<T>(queryParams, paramsFormat);
};

// INFO: --- Helpers for generateUrlParams ---
function getFbc(generatedFbc: string, cookieFbclid: string) {
	const fbc = getCookie('_fbc');

	if (fbc) {
		return fbc;
	}
	if (generatedFbc) {
		return generatedFbc;
	}

	let params = new URLSearchParams(windowIsReady ? window.location.search : '');
	let fbclid = params.get('fbclid') ?? cookieFbclid;
	return fbc || generateFbc(fbclid, generatedFbc);
}

function getFbp() {
	const fbp = getCookie('_fbp');
	return fbp || null;
}

function generateFbc(fbclid: string, generatedFbc: string) {
	if (!fbclid) {
		return null;
	}
	generatedFbc = `fb.1.${Date.now()}.${fbclid}`;
	return generatedFbc;
}

function getCookie(cname: string) {
	let name = `${cname}=`;
	let decodedCookie = windowIsReady ? decodeURIComponent(document.cookie) : '';
	let ca = decodedCookie.split(';');
	for (let i = 0; i < ca.length; i++) {
		let c = ca[i];
		while (c.charAt(0) === ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) === 0) {
			return c.substring(name.length, c.length);
		}
	}
	return '';
}
